import { render, staticRenderFns } from "./AfflictionReport.vue?vue&type=template&id=f663af96"
import script from "./AfflictionReport.vue?vue&type=script&lang=js"
export * from "./AfflictionReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports